import {useMutation, useQueryClient} from 'react-query'
import {TimeSlot} from "../../../types";
import {showNotification} from "@mantine/notifications";
import {Check} from "tabler-icons-react";

const onMutateSuccess = (values: TimeSlot) => {
    showNotification({
        title: 'Time slot updated',
        icon: <Check/>,
        message: `Time slot has been updated!`,
    })
}

const onMutateError = (error: string) => {
    showNotification({
        title: `Something went wrong`,
        message: `An error occurred while updating the time slot. ${error}`,
        color: 'red'
    })
}

export default function useMutateTimeSlotData(mutationFn: (args: any) => Promise<unknown>, onSuccess: any = onMutateSuccess, onError: any = onMutateError) {
    const queryClient = useQueryClient();
    return useMutation(mutationFn, {
        onSuccess: (data) => {
            // Reload timeSlot data
            queryClient.invalidateQueries(['timeSlots']);

            onSuccess?.(data)
        },
        onError: (data) => onError?.(data)
    });
}
